import { Injectable } from '@angular/core';

import { Location } from '@shared/location/models';
import { EnabledDisabledFilterEnum, ILocationFilters } from './models';

@Injectable()
export class LocationsFilterService {

  filterLocations({ info, planCode, availability }: ILocationFilters, locations: Location[]): Location[] {
    return locations.filter(location => this.compareByInfo(info, location)
      && this.compareByPlanCode(planCode, location)
      && this.compareByAvailability(availability, location));
  }

  private compareByInfo(data: string, location: Location): boolean {
    if (data === '') {
      return true;
    }

    const {name, address, phoneNumber} = location;

    return name.toLowerCase().includes(data)
      || phoneNumber?.includes(data)
      || address?.primaryAddress.toLowerCase().includes(data)
      || address?.additionalAddress.toLowerCase().includes(data);
  }

  private compareByPlanCode(data: string, location: Location): boolean {
    return data ? location.recurly.planCode === data : true;
  }

  private compareByAvailability(data: EnabledDisabledFilterEnum, location: Location): boolean {
    if (!data) {
      return true;
    }

    return data === EnabledDisabledFilterEnum.enabled ? location.enabled : !location.enabled;
  }
}
